function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "nonzero",
  d: "M3.628 0v1.244h5.744V0h1.008v1.244h.772c1.02 0 1.848.816 1.848 1.824v8.108A1.836 1.836 0 0 1 11.152 13H1.848A1.836 1.836 0 0 1 0 11.176V3.068C0 2.06.827 1.244 1.848 1.244h.772V0h1.008zm8.364 5.074H1.008v6.102c0 .458.376.83.84.83h9.304a.845.845 0 0 0 .594-.244.824.824 0 0 0 .246-.586V5.074zM7.61 8.854v2.171h-2.2v-2.17h2.2zm-3.125 0v2.171h-2.2v-2.17h2.2zm6.249 0v2.171h-2.2v-2.17h2.2zM7.609 6.037v2.17h-2.2v-2.17h2.2zm-3.125 0v2.17h-2.2v-2.17h2.2zm6.249 0v2.17h-2.2v-2.17h2.2zM2.637 2.239h-.79a.834.834 0 0 0-.84.829v1.011h10.985V3.068a.834.834 0 0 0-.84-.83h-.772v1.078H9.372V2.24H3.645v1.077H2.637V2.24z"
});

var SvgCalender = function SvgCalender(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCalender, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/calender.e7759907.svg";
export { ForwardRef as ReactComponent };